import moment from "moment";
import { Modal } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import "./BranchStatusListModal.scss";

const BranchStatusListModal = ({ t, show, onHide, rows, statusLabel }) => {
    const items = rows || [];

    return (
        <Modal show={show} onHide={onHide} centered className="branch-status-list-modal">
            <Modal.Header closeButton>
                <Modal.Title>{statusLabel}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {items.length === 0 ? (
                    <p className="text-secondary mb-0">{t("Nodatafound.label")}</p>
                ) : (
                    <ul className="branch-status-list-modal__list list-unstyled mb-0">
                        {items.map((item, index) => (
                            <li key={item.submissionId ?? index}>
                                <div className="branch-status-list-modal__branch">
                                    <span className="branch-status-list-modal__parent" title={item.parentBranchName}>
                                        {item.parentBranchName}
                                    </span>
                                    {item.childBranchId != null && item.childBranchId !== item.parentBranchId && (
                                        <span className="branch-status-list-modal__child" title={item.childBranchName}>
                                            {item.childBranchName}
                                        </span>
                                    )}
                                </div>
                                <span className="branch-status-list-modal__assessment">
                                    {item.assessmentName}{item.reportingPeriod ? `-${moment(item.reportingPeriod).format("MMMM, YYYY")}` : ''}
                                </span>
                            </li>
                        ))}
                    </ul>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default withTranslation()(BranchStatusListModal);
